export default {
      id: "calendar-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#calendar-new",
      toString: function () {
        return this.url;
      }
    }